import React from 'react';
import { Icon, Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const DatasetStorageErrorRow = ({ error, colSpan }) => (
  <Table.Row>
    <Table.Cell colSpan={colSpan} collapsing className="aridhia-table-error">
      <Icon size="large" name="times circle" color="red" />
      <FormattedMessage id="error.title" />
      {error && <FormattedMessage id="error.message" values={{ error: error.message }} />}
      {!error && <FormattedMessage id="dataset.storage.error" />}
    </Table.Cell>
  </Table.Row>
);

export default DatasetStorageErrorRow;
